const COMMERCIAL_INTELLIGENCE_PREFIX = "/commercial-intelligence";

/**
 * Rewards ("Incentivos") and RewardTypes pages are mounted twice: under the
 * legacy /fidelity/* routes and under /commercial-intelligence/* (Bright
 * Actions). Both mounts render the same components, so in-page navigation
 * must stay under whichever prefix the user is currently on — otherwise the
 * sidebar switches to the other menu (see Layout.tsx / MenuContext.tsx).
 */
export const getRewardsBasePath = (pathname: string) =>
  pathname.startsWith(COMMERCIAL_INTELLIGENCE_PREFIX)
    ? "/commercial-intelligence/opportunities/incentives"
    : "/fidelity/rewards";

export const getRewardTypesBasePath = (pathname: string) =>
  pathname.startsWith(COMMERCIAL_INTELLIGENCE_PREFIX)
    ? "/commercial-intelligence/configuration/reward-types"
    : "/fidelity/rewardtypes";
